import React from 'react';

import { Card } from 'semantic-ui-react'

import ShopCardComponent from './shopCardComponent'

import { ShopCard, ActionType, Team, Action, DraftData } from '../types';

import { useMeleeContext } from '../context/MeleeContextProvider'
import { AddToHistory } from '../utils/roundHandler';
import { AndAnotherOne, Surrekamp, BanFiesta, StageWarp, DuelTrade, SecretSanta } from '../utils/cardEvents'

interface Props {
  cards?: ShopCard[]
  currentAction?: Action,
  setCurrentAction: (action: ActionType, team: Team) => void,
  setCardPurchased: (index: number, team: Team) => void,
  executeAction: (prevRoundData?: DraftData) => void,
  addActionToSequence: (action: Action, atStart?: boolean) => DraftData | void
}

export default function CardTable(props: Props) {
  const context = useMeleeContext();
  if (!context) throw new Error();

  const purchaseCard = (effects: string[], cardPurchasedIndex: number): void => {
    AddToHistory(context.gameData)
    const buyingTeam = props.currentAction!.Team;
    props.setCardPurchased(cardPurchasedIndex, buyingTeam);

    effects.forEach((effect, index) => {
      const decodedEffect = effect.split(':');
      //Om DecodedEffect > 1, er det en select
      if (decodedEffect.length > 1 && decodedEffect[0] === 'select') {
        const target = decodedEffect[1] === 'enemy' ? ActionType.SelectEnemey : ActionType.SelectFriendly;
        //Hvis det er flere commands som kommer etter, legger vi den i actonSequence, ellers setter vi den som current
        if (index + 1 === decodedEffect.length) {
          props.setCurrentAction(target, buyingTeam);
        } else {
          if (!context.gameData.ActionSequence) return;
          context.gameData.ActionSequence.push({
            Action: target,
            Team: buyingTeam,
          });
        }
      }
      switch (effect) {
        case 'addBan':
          props.setCurrentAction(ActionType.Ban, buyingTeam);
          return
        case 'anotherOne':
          context.setGameData(AndAnotherOne(context!.gameData));
          props.executeAction();
          return
        case 'surrekamp':
          context.setGameData(Surrekamp(context!.gameData, context.draftOptions.stagePack));
          props.executeAction();
          return
        case 'banFiesta':
          context.setGameData(BanFiesta(context!.gameData))
          props.executeAction();
          return;
        case 'stageWarp':
          context.setGameData(StageWarp(context!.gameData, context.draftOptions.stagePack))
          props.executeAction();
          return;
        case 'secretSanta':
          context.setGameData(SecretSanta(context!.gameData, cardPurchasedIndex))
          return;
        case 'cuckio':
          props.addActionToSequence({
            Action: ActionType.CardEffect,
            Team: buyingTeam,
            CardEffect: effect
          });
          props.setCurrentAction(ActionType.Ban, buyingTeam);
          return;
        case 'swap':
          const temp = props.addActionToSequence({
            Action: ActionType.CardEffect,
            Team: buyingTeam,
            CardEffect: effect
          }, true);
          temp && props.executeAction(temp);
          return;
        case 'trade':
        case 'reroll':
        case 'randomHero':
          props.addActionToSequence({
            Action: ActionType.CardEffect,
            Team: buyingTeam,
            CardEffect: effect
          });
          return;
        case 'duelTrade':
          context.setGameData(DuelTrade(context!.gameData))
          props.executeAction();
          return;
        case 'doppelganger':
          props.addActionToSequence({
            Action: ActionType.CardEffect,
            Team: buyingTeam,
            CardEffect: 'doppelganger'
          });
          props.addActionToSequence({
            Action: ActionType.SelectEnemey,
            Team: buyingTeam,
          });
          props.addActionToSequence({
            Action: ActionType.CardEffect,
            Team: buyingTeam,
            CardEffect: 'doppelganger'
          });
          props.addActionToSequence({
            Action: ActionType.SelectFriendly,
            Team: buyingTeam,
          });
          props.executeAction();
          return
        case 'none':
          props.executeAction();
          return
      }
    })
  }

  return (
    <Card.Group centered itemsPerRow={3} stackable>
      {props.cards && props.cards.map(c => {
        var action = props.currentAction ? props.currentAction.Action : undefined;
        return (
          <ShopCardComponent
            card={c}
            purchaseCard={purchaseCard}
            currentAction={action}
            key={`shop-card-${c.Index}`}
          />
        )
      }
      )}
    </Card.Group>
  )
}
